// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=none,json_types=true"
// @generated from file protobuf/journey/data/categories/marketplace_property_category.proto (package od_protos.journey.data.categories, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Int32ValueJson, Int64ValueJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import { file_protobuf_journey_data_options_options } from "../options/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file protobuf/journey/data/categories/marketplace_property_category.proto.
 */
export const file_protobuf_journey_data_categories_marketplace_property_category: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_protobuf_journey_data_options_options]);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory
 */
export type MarketplacePropertyCategory = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory"> & {
  /**
   * Next ID: 40
   *
   * @generated from oneof od_protos.journey.data.categories.MarketplacePropertyCategory.event
   */
  event: {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent detail_page_view = 1;
     */
    value: MarketplacePropertyCategory_DetailPageViewEvent;
    case: "detailPageView";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent similar_homes_click = 2;
     */
    value: MarketplacePropertyCategory_SimilarHomesClickEvent;
    case: "similarHomesClick";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent tour_booking_start = 3;
     */
    value: MarketplacePropertyCategory_TourBookingStartEvent;
    case: "tourBookingStart";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent reaction = 4;
     */
    value: MarketplacePropertyCategory_ReactionEvent;
    case: "reaction";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent offer_start = 5;
     */
    value: MarketplacePropertyCategory_OfferStartEvent;
    case: "offerStart";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent share = 6;
     */
    value: MarketplacePropertyCategory_ShareEvent;
    case: "share";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent rental_scam_banner_view = 7;
     */
    value: MarketplacePropertyCategory_RentalScamBannerViewEvent;
    case: "rentalScamBannerView";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent rental_scam_banner_learn_more = 8;
     */
    value: MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent;
    case: "rentalScamBannerLearnMore";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent natural_language_search = 9;
     */
    value: MarketplacePropertyCategory_NaturalLanguageSearchEvent;
    case: "naturalLanguageSearch";
  } | {
    /**
     * Tour booking funnel
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent tour_flow_started = 10;
     */
    value: MarketplacePropertyCategory_TourFlowStartedEvent;
    case: "tourFlowStarted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent tour_slot_selected = 11;
     */
    value: MarketplacePropertyCategory_TourSlotSelectedEvent;
    case: "tourSlotSelected";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent tour_verification_started = 12;
     */
    value: MarketplacePropertyCategory_TourVerificationStartedEvent;
    case: "tourVerificationStarted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent tour_verification_completed = 13;
     */
    value: MarketplacePropertyCategory_TourVerificationCompletedEvent;
    case: "tourVerificationCompleted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent tour_booking_attempted = 14;
     */
    value: MarketplacePropertyCategory_TourBookingAttemptedEvent;
    case: "tourBookingAttempted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent tour_booking_completed = 15;
     */
    value: MarketplacePropertyCategory_TourBookingCompletedEvent;
    case: "tourBookingCompleted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent tour_flow_abandoned = 16;
     */
    value: MarketplacePropertyCategory_TourFlowAbandonedEvent;
    case: "tourFlowAbandoned";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent idv_session_denied = 17;
     */
    value: MarketplacePropertyCategory_IdvSessionDeniedEvent;
    case: "idvSessionDenied";
  } | {
    /**
     * Tour management
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent tour_cancel_confirmed = 18;
     */
    value: MarketplacePropertyCategory_TourCancelConfirmedEvent;
    case: "tourCancelConfirmed";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent tour_cancel_succeeded = 19;
     */
    value: MarketplacePropertyCategory_TourCancelSucceededEvent;
    case: "tourCancelSucceeded";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent tour_feedback_submitted = 20;
     */
    value: MarketplacePropertyCategory_TourFeedbackSubmittedEvent;
    case: "tourFeedbackSubmitted";
  } | {
    /**
     * Tour entry
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent access_code_loaded = 21;
     */
    value: MarketplacePropertyCategory_AccessCodeLoadedEvent;
    case: "accessCodeLoaded";
  } | {
    /**
     * Search
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent search_result_selected = 22;
     */
    value: MarketplacePropertyCategory_SearchResultSelectedEvent;
    case: "searchResultSelected";
  } | {
    /**
     * Globe usage
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent map_globe_entered = 23;
     */
    value: MarketplacePropertyCategory_MapGlobeEnteredEvent;
    case: "mapGlobeEntered";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent map_globe_exited = 24;
     */
    value: MarketplacePropertyCategory_MapGlobeExitedEvent;
    case: "mapGlobeExited";
  } | {
    /**
     * Carousel engagement
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent carousel_engagement = 25;
     */
    value: MarketplacePropertyCategory_CarouselEngagementEvent;
    case: "carouselEngagement";
  } | {
    /**
     * Buyer conversion signals
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent property_search = 26;
     */
    value: MarketplacePropertyCategory_PropertySearchEvent;
    case: "propertySearch";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent add_favorite = 27;
     */
    value: MarketplacePropertyCategory_AddFavoriteEvent;
    case: "addFavorite";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent offer_submitted = 28;
     */
    value: MarketplacePropertyCategory_OfferSubmittedEvent;
    case: "offerSubmitted";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent account_created = 29;
     */
    value: MarketplacePropertyCategory_AccountCreatedEvent;
    case: "accountCreated";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent tour_scheduled = 30;
     */
    value: MarketplacePropertyCategory_TourScheduledEvent;
    case: "tourScheduled";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent tour_completed = 31;
     */
    value: MarketplacePropertyCategory_TourCompletedEvent;
    case: "tourCompleted";
  } | {
    /**
     * Certainty panel (PDP)
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent certainty_panel_view = 32;
     */
    value: MarketplacePropertyCategory_CertaintyPanelViewEvent;
    case: "certaintyPanelView";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent certainty_panel_click = 33;
     */
    value: MarketplacePropertyCategory_CertaintyPanelClickEvent;
    case: "certaintyPanelClick";
  } | {
    /**
     * Media slot (PDP)
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent listing_media_impression = 34;
     */
    value: MarketplacePropertyCategory_ListingMediaImpressionEvent;
    case: "listingMediaImpression";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent listing_media_toggle = 35;
     */
    value: MarketplacePropertyCategory_ListingMediaToggleEvent;
    case: "listingMediaToggle";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent listing_video_playback = 36;
     */
    value: MarketplacePropertyCategory_ListingVideoPlaybackEvent;
    case: "listingVideoPlayback";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent offer_checkout_step = 37;
     */
    value: MarketplacePropertyCategory_OfferCheckoutStepEvent;
    case: "offerCheckoutStep";
  } | {
    /**
     * Tour lifecycle
     *
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent tour_canceled = 38;
     */
    value: MarketplacePropertyCategory_TourCanceledEvent;
    case: "tourCanceled";
  } | {
    /**
     * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent tour_rescheduled = 39;
     */
    value: MarketplacePropertyCategory_TourRescheduledEvent;
    case: "tourRescheduled";
  } | { case: undefined; value?: undefined };
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory
 */
export type MarketplacePropertyCategoryJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent detail_page_view = 1;
   */
  detailPageView?: MarketplacePropertyCategory_DetailPageViewEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent similar_homes_click = 2;
   */
  similarHomesClick?: MarketplacePropertyCategory_SimilarHomesClickEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent tour_booking_start = 3;
   */
  tourBookingStart?: MarketplacePropertyCategory_TourBookingStartEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent reaction = 4;
   */
  reaction?: MarketplacePropertyCategory_ReactionEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent offer_start = 5;
   */
  offerStart?: MarketplacePropertyCategory_OfferStartEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent share = 6;
   */
  share?: MarketplacePropertyCategory_ShareEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent rental_scam_banner_view = 7;
   */
  rentalScamBannerView?: MarketplacePropertyCategory_RentalScamBannerViewEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent rental_scam_banner_learn_more = 8;
   */
  rentalScamBannerLearnMore?: MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent natural_language_search = 9;
   */
  naturalLanguageSearch?: MarketplacePropertyCategory_NaturalLanguageSearchEventJson;

  /**
   * Tour booking funnel
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent tour_flow_started = 10;
   */
  tourFlowStarted?: MarketplacePropertyCategory_TourFlowStartedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent tour_slot_selected = 11;
   */
  tourSlotSelected?: MarketplacePropertyCategory_TourSlotSelectedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent tour_verification_started = 12;
   */
  tourVerificationStarted?: MarketplacePropertyCategory_TourVerificationStartedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent tour_verification_completed = 13;
   */
  tourVerificationCompleted?: MarketplacePropertyCategory_TourVerificationCompletedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent tour_booking_attempted = 14;
   */
  tourBookingAttempted?: MarketplacePropertyCategory_TourBookingAttemptedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent tour_booking_completed = 15;
   */
  tourBookingCompleted?: MarketplacePropertyCategory_TourBookingCompletedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent tour_flow_abandoned = 16;
   */
  tourFlowAbandoned?: MarketplacePropertyCategory_TourFlowAbandonedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent idv_session_denied = 17;
   */
  idvSessionDenied?: MarketplacePropertyCategory_IdvSessionDeniedEventJson;

  /**
   * Tour management
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent tour_cancel_confirmed = 18;
   */
  tourCancelConfirmed?: MarketplacePropertyCategory_TourCancelConfirmedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent tour_cancel_succeeded = 19;
   */
  tourCancelSucceeded?: MarketplacePropertyCategory_TourCancelSucceededEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent tour_feedback_submitted = 20;
   */
  tourFeedbackSubmitted?: MarketplacePropertyCategory_TourFeedbackSubmittedEventJson;

  /**
   * Tour entry
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent access_code_loaded = 21;
   */
  accessCodeLoaded?: MarketplacePropertyCategory_AccessCodeLoadedEventJson;

  /**
   * Search
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent search_result_selected = 22;
   */
  searchResultSelected?: MarketplacePropertyCategory_SearchResultSelectedEventJson;

  /**
   * Globe usage
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent map_globe_entered = 23;
   */
  mapGlobeEntered?: MarketplacePropertyCategory_MapGlobeEnteredEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent map_globe_exited = 24;
   */
  mapGlobeExited?: MarketplacePropertyCategory_MapGlobeExitedEventJson;

  /**
   * Carousel engagement
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent carousel_engagement = 25;
   */
  carouselEngagement?: MarketplacePropertyCategory_CarouselEngagementEventJson;

  /**
   * Buyer conversion signals
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent property_search = 26;
   */
  propertySearch?: MarketplacePropertyCategory_PropertySearchEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent add_favorite = 27;
   */
  addFavorite?: MarketplacePropertyCategory_AddFavoriteEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent offer_submitted = 28;
   */
  offerSubmitted?: MarketplacePropertyCategory_OfferSubmittedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent account_created = 29;
   */
  accountCreated?: MarketplacePropertyCategory_AccountCreatedEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent tour_scheduled = 30;
   */
  tourScheduled?: MarketplacePropertyCategory_TourScheduledEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent tour_completed = 31;
   */
  tourCompleted?: MarketplacePropertyCategory_TourCompletedEventJson;

  /**
   * Certainty panel (PDP)
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent certainty_panel_view = 32;
   */
  certaintyPanelView?: MarketplacePropertyCategory_CertaintyPanelViewEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent certainty_panel_click = 33;
   */
  certaintyPanelClick?: MarketplacePropertyCategory_CertaintyPanelClickEventJson;

  /**
   * Media slot (PDP)
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent listing_media_impression = 34;
   */
  listingMediaImpression?: MarketplacePropertyCategory_ListingMediaImpressionEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent listing_media_toggle = 35;
   */
  listingMediaToggle?: MarketplacePropertyCategory_ListingMediaToggleEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent listing_video_playback = 36;
   */
  listingVideoPlayback?: MarketplacePropertyCategory_ListingVideoPlaybackEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent offer_checkout_step = 37;
   */
  offerCheckoutStep?: MarketplacePropertyCategory_OfferCheckoutStepEventJson;

  /**
   * Tour lifecycle
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent tour_canceled = 38;
   */
  tourCanceled?: MarketplacePropertyCategory_TourCanceledEventJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent tour_rescheduled = 39;
   */
  tourRescheduled?: MarketplacePropertyCategory_TourRescheduledEventJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.
 * Use `create(MarketplacePropertyCategorySchema)` to create a new message.
 */
export const MarketplacePropertyCategorySchema: GenMessage<MarketplacePropertyCategory, {jsonType: MarketplacePropertyCategoryJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent
 */
export type MarketplacePropertyCategory_DetailPageViewEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent
 */
export type MarketplacePropertyCategory_DetailPageViewEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.DetailPageViewEvent.
 * Use `create(MarketplacePropertyCategory_DetailPageViewEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_DetailPageViewEventSchema: GenMessage<MarketplacePropertyCategory_DetailPageViewEvent, {jsonType: MarketplacePropertyCategory_DetailPageViewEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent
 */
export type MarketplacePropertyCategory_SimilarHomesClickEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string clicked_address_uuid = 2;
   */
  clickedAddressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent
 */
export type MarketplacePropertyCategory_SimilarHomesClickEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string clicked_address_uuid = 2;
   */
  clickedAddressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.SimilarHomesClickEvent.
 * Use `create(MarketplacePropertyCategory_SimilarHomesClickEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_SimilarHomesClickEventSchema: GenMessage<MarketplacePropertyCategory_SimilarHomesClickEvent, {jsonType: MarketplacePropertyCategory_SimilarHomesClickEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 1);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent
 */
export type MarketplacePropertyCategory_TourBookingStartEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string placement = 2;
   */
  placement: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;

  /**
   * Tour path (self-tour vs tour-with-agent); placement keeps page position.
   *
   * @generated from field: string source = 4;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent
 */
export type MarketplacePropertyCategory_TourBookingStartEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string placement = 2;
   */
  placement?: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;

  /**
   * Tour path (self-tour vs tour-with-agent); placement keeps page position.
   *
   * @generated from field: string source = 4;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingStartEvent.
 * Use `create(MarketplacePropertyCategory_TourBookingStartEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourBookingStartEventSchema: GenMessage<MarketplacePropertyCategory_TourBookingStartEvent, {jsonType: MarketplacePropertyCategory_TourBookingStartEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 2);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent
 */
export type MarketplacePropertyCategory_ReactionEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction reaction = 3;
   */
  reaction: MarketplacePropertyCategory_ReactionEventReaction;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent
 */
export type MarketplacePropertyCategory_ReactionEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction reaction = 3;
   */
  reaction?: MarketplacePropertyCategory_ReactionEventReactionJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEvent.
 * Use `create(MarketplacePropertyCategory_ReactionEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ReactionEventSchema: GenMessage<MarketplacePropertyCategory_ReactionEvent, {jsonType: MarketplacePropertyCategory_ReactionEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 3);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent
 */
export type MarketplacePropertyCategory_OfferStartEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent
 */
export type MarketplacePropertyCategory_OfferStartEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferStartEvent.
 * Use `create(MarketplacePropertyCategory_OfferStartEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_OfferStartEventSchema: GenMessage<MarketplacePropertyCategory_OfferStartEvent, {jsonType: MarketplacePropertyCategory_OfferStartEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 4);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent
 */
export type MarketplacePropertyCategory_ShareEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent
 */
export type MarketplacePropertyCategory_ShareEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ShareEvent.
 * Use `create(MarketplacePropertyCategory_ShareEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ShareEventSchema: GenMessage<MarketplacePropertyCategory_ShareEvent, {jsonType: MarketplacePropertyCategory_ShareEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 5);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerViewEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerViewEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerViewEvent.
 * Use `create(MarketplacePropertyCategory_RentalScamBannerViewEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_RentalScamBannerViewEventSchema: GenMessage<MarketplacePropertyCategory_RentalScamBannerViewEvent, {jsonType: MarketplacePropertyCategory_RentalScamBannerViewEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 6);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent
 */
export type MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.RentalScamBannerLearnMoreEvent.
 * Use `create(MarketplacePropertyCategory_RentalScamBannerLearnMoreEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_RentalScamBannerLearnMoreEventSchema: GenMessage<MarketplacePropertyCategory_RentalScamBannerLearnMoreEvent, {jsonType: MarketplacePropertyCategory_RentalScamBannerLearnMoreEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 7);

/**
 * One event per natural-language search engine call, emitted server-side by
 * Athena so iOS and web are covered without a client release. Deliberately
 * carries the raw query text: capturing what buyers ask for is this event's
 * purpose, and nothing else in the stack persists it (the engine's own
 * telemetry is bounded enums only). Map surfaces re-issue the engine call on
 * every viewport settle, so consumers should expect several rows per typed
 * query and dedupe on (identity, query, surface) over a time window.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent
 */
export type MarketplacePropertyCategory_NaturalLanguageSearchEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent"> & {
  /**
   * @generated from field: string query = 1;
   */
  query: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface surface = 2;
   */
  surface: MarketplacePropertyCategory_NaturalLanguageSearchEvent_Surface;

  /**
   * @generated from field: string graphql_client_name = 3;
   */
  graphqlClientName: string;

  /**
   * @generated from field: string market = 4;
   */
  market: string;

  /**
   * Whether the request carried a viewport bounding box (bounded searches
   * are viewport-scoped; unbounded ones are nationwide).
   *
   * @generated from field: bool bounded = 5;
   */
  bounded: boolean;

  /**
   * Wrapper rather than a bare int: the standalone query legitimately
   * omits limit (the engine applies its default), and a warehouse row must
   * distinguish that from a real zero because results_truncated is only
   * interpretable against the page size.
   *
   * @generated from field: google.protobuf.Int32Value limit = 6;
   */
  limit?: number | undefined;

  /**
   * Geohash precision of the clustered fetch; absent for pins/standalone.
   *
   * @generated from field: google.protobuf.Int32Value cluster_precision = 7;
   */
  clusterPrecision?: number | undefined;

  /**
   * @generated from field: int32 homes_returned = 8;
   */
  homesReturned: number;

  /**
   * @generated from field: string empty_reason = 9;
   */
  emptyReason: string;

  /**
   * @generated from field: bool results_truncated = 10;
   */
  resultsTruncated: boolean;

  /**
   * @generated from field: int64 engine_latency_ms = 11;
   */
  engineLatencyMs: bigint;
};

/**
 * One event per natural-language search engine call, emitted server-side by
 * Athena so iOS and web are covered without a client release. Deliberately
 * carries the raw query text: capturing what buyers ask for is this event's
 * purpose, and nothing else in the stack persists it (the engine's own
 * telemetry is bounded enums only). Map surfaces re-issue the engine call on
 * every viewport settle, so consumers should expect several rows per typed
 * query and dedupe on (identity, query, surface) over a time window.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent
 */
export type MarketplacePropertyCategory_NaturalLanguageSearchEventJson = {
  /**
   * @generated from field: string query = 1;
   */
  query?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface surface = 2;
   */
  surface?: MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceJson;

  /**
   * @generated from field: string graphql_client_name = 3;
   */
  graphqlClientName?: string;

  /**
   * @generated from field: string market = 4;
   */
  market?: string;

  /**
   * Whether the request carried a viewport bounding box (bounded searches
   * are viewport-scoped; unbounded ones are nationwide).
   *
   * @generated from field: bool bounded = 5;
   */
  bounded?: boolean;

  /**
   * Wrapper rather than a bare int: the standalone query legitimately
   * omits limit (the engine applies its default), and a warehouse row must
   * distinguish that from a real zero because results_truncated is only
   * interpretable against the page size.
   *
   * @generated from field: google.protobuf.Int32Value limit = 6;
   */
  limit?: Int32ValueJson;

  /**
   * Geohash precision of the clustered fetch; absent for pins/standalone.
   *
   * @generated from field: google.protobuf.Int32Value cluster_precision = 7;
   */
  clusterPrecision?: Int32ValueJson;

  /**
   * @generated from field: int32 homes_returned = 8;
   */
  homesReturned?: number;

  /**
   * @generated from field: string empty_reason = 9;
   */
  emptyReason?: string;

  /**
   * @generated from field: bool results_truncated = 10;
   */
  resultsTruncated?: boolean;

  /**
   * @generated from field: int64 engine_latency_ms = 11;
   */
  engineLatencyMs?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.
 * Use `create(MarketplacePropertyCategory_NaturalLanguageSearchEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_NaturalLanguageSearchEventSchema: GenMessage<MarketplacePropertyCategory_NaturalLanguageSearchEvent, {jsonType: MarketplacePropertyCategory_NaturalLanguageSearchEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 8);

/**
 * Athena surface that issued the engine call. The map surfaces mirror
 * marketplace.propertySearch's fetch split: a clustered fetch renders
 * count bubbles, a pins fetch renders individual homes.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface
 */
export enum MarketplacePropertyCategory_NaturalLanguageSearchEvent_Surface {
  /**
   * @generated from enum value: SURFACE_UNSPECIFIED = 0;
   */
  SURFACE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: STANDALONE = 1;
   */
  STANDALONE = 1,

  /**
   * @generated from enum value: MAP_CLUSTERS = 2;
   */
  MAP_CLUSTERS = 2,

  /**
   * @generated from enum value: MAP_PINS = 3;
   */
  MAP_PINS = 3,
}

/**
 * Athena surface that issued the engine call. The map surfaces mirror
 * marketplace.propertySearch's fetch split: a clustered fetch renders
 * count bubbles, a pins fetch renders individual homes.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface
 */
export type MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceJson = "SURFACE_UNSPECIFIED" | "STANDALONE" | "MAP_CLUSTERS" | "MAP_PINS";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.NaturalLanguageSearchEvent.Surface.
 */
export const MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceSchema: GenEnum<MarketplacePropertyCategory_NaturalLanguageSearchEvent_Surface, MarketplacePropertyCategory_NaturalLanguageSearchEvent_SurfaceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 8, 0);

/**
 * Tour booking funnel — emitted by iOS at each step from "Schedule Tour"
 * through identity verification and booking submission. Together with
 * TourBookingStartEvent above, these support drop-off analysis. Client
 * errors are deliberately not modeled here: they go to Sentry, and a
 * funnel gap (started without completed) marks the drop-off.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent
 */
export type MarketplacePropertyCategory_TourFlowStartedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: bool can_tour_now = 2;
   */
  canTourNow: boolean;

  /**
   * @generated from field: bool is_verified = 3;
   */
  isVerified: boolean;
};

/**
 * Tour booking funnel — emitted by iOS at each step from "Schedule Tour"
 * through identity verification and booking submission. Together with
 * TourBookingStartEvent above, these support drop-off analysis. Client
 * errors are deliberately not modeled here: they go to Sentry, and a
 * funnel gap (started without completed) marks the drop-off.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent
 */
export type MarketplacePropertyCategory_TourFlowStartedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: bool can_tour_now = 2;
   */
  canTourNow?: boolean;

  /**
   * @generated from field: bool is_verified = 3;
   */
  isVerified?: boolean;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowStartedEvent.
 * Use `create(MarketplacePropertyCategory_TourFlowStartedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFlowStartedEventSchema: GenMessage<MarketplacePropertyCategory_TourFlowStartedEvent, {jsonType: MarketplacePropertyCategory_TourFlowStartedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 9);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent
 */
export type MarketplacePropertyCategory_TourSlotSelectedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime: string;

  /**
   * @generated from field: bool is_tour_now = 3;
   */
  isTourNow: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup time_group = 4;
   */
  timeGroup: MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroup;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent
 */
export type MarketplacePropertyCategory_TourSlotSelectedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime?: string;

  /**
   * @generated from field: bool is_tour_now = 3;
   */
  isTourNow?: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup time_group = 4;
   */
  timeGroup?: MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.
 * Use `create(MarketplacePropertyCategory_TourSlotSelectedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourSlotSelectedEventSchema: GenMessage<MarketplacePropertyCategory_TourSlotSelectedEvent, {jsonType: MarketplacePropertyCategory_TourSlotSelectedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 10);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup
 */
export enum MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroup {
  /**
   * @generated from enum value: TIME_GROUP_UNSPECIFIED = 0;
   */
  TIME_GROUP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MORNING = 1;
   */
  MORNING = 1,

  /**
   * @generated from enum value: AFTERNOON = 2;
   */
  AFTERNOON = 2,

  /**
   * @generated from enum value: EVENING = 3;
   */
  EVENING = 3,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup
 */
export type MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupJson = "TIME_GROUP_UNSPECIFIED" | "MORNING" | "AFTERNOON" | "EVENING";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourSlotSelectedEvent.TimeGroup.
 */
export const MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupSchema: GenEnum<MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroup, MarketplacePropertyCategory_TourSlotSelectedEvent_TimeGroupJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 10, 0);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent
 */
export type MarketplacePropertyCategory_TourVerificationStartedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step: MarketplacePropertyCategory_VerificationStep;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent
 */
export type MarketplacePropertyCategory_TourVerificationStartedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step?: MarketplacePropertyCategory_VerificationStepJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationStartedEvent.
 * Use `create(MarketplacePropertyCategory_TourVerificationStartedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourVerificationStartedEventSchema: GenMessage<MarketplacePropertyCategory_TourVerificationStartedEvent, {jsonType: MarketplacePropertyCategory_TourVerificationStartedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 11);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent
 */
export type MarketplacePropertyCategory_TourVerificationCompletedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step: MarketplacePropertyCategory_VerificationStep;

  /**
   * Wrapper rather than a bare int: the emitter loses the step-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous step.
   *
   * @generated from field: google.protobuf.Int32Value duration_ms = 3;
   */
  durationMs?: number | undefined;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent
 */
export type MarketplacePropertyCategory_TourVerificationCompletedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep step = 2;
   */
  step?: MarketplacePropertyCategory_VerificationStepJson;

  /**
   * Wrapper rather than a bare int: the emitter loses the step-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous step.
   *
   * @generated from field: google.protobuf.Int32Value duration_ms = 3;
   */
  durationMs?: Int32ValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourVerificationCompletedEvent.
 * Use `create(MarketplacePropertyCategory_TourVerificationCompletedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourVerificationCompletedEventSchema: GenMessage<MarketplacePropertyCategory_TourVerificationCompletedEvent, {jsonType: MarketplacePropertyCategory_TourVerificationCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 12);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent
 */
export type MarketplacePropertyCategory_TourBookingAttemptedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent
 */
export type MarketplacePropertyCategory_TourBookingAttemptedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string slot_time = 2;
   */
  slotTime?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingAttemptedEvent.
 * Use `create(MarketplacePropertyCategory_TourBookingAttemptedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourBookingAttemptedEventSchema: GenMessage<MarketplacePropertyCategory_TourBookingAttemptedEvent, {jsonType: MarketplacePropertyCategory_TourBookingAttemptedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 13);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent
 */
export type MarketplacePropertyCategory_TourBookingCompletedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId: string;

  /**
   * @generated from field: string slot_time = 3;
   */
  slotTime: string;

  /**
   * Wrapper rather than a bare int: the emitter loses the flow-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous booking.
   *
   * @generated from field: google.protobuf.Int32Value total_flow_duration_ms = 4;
   */
  totalFlowDurationMs?: number | undefined;

  /**
   * @generated from field: int32 steps_count = 5;
   */
  stepsCount: number;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent
 */
export type MarketplacePropertyCategory_TourBookingCompletedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string booking_id = 2;
   */
  bookingId?: string;

  /**
   * @generated from field: string slot_time = 3;
   */
  slotTime?: string;

  /**
   * Wrapper rather than a bare int: the emitter loses the flow-start
   * timestamp across process restarts, and a warehouse row must
   * distinguish "unmeasured" from an instantaneous booking.
   *
   * @generated from field: google.protobuf.Int32Value total_flow_duration_ms = 4;
   */
  totalFlowDurationMs?: Int32ValueJson;

  /**
   * @generated from field: int32 steps_count = 5;
   */
  stepsCount?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourBookingCompletedEvent.
 * Use `create(MarketplacePropertyCategory_TourBookingCompletedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourBookingCompletedEventSchema: GenMessage<MarketplacePropertyCategory_TourBookingCompletedEvent, {jsonType: MarketplacePropertyCategory_TourBookingCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 14);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent
 */
export type MarketplacePropertyCategory_TourFlowAbandonedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep last_step = 2;
   */
  lastStep: MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep;

  /**
   * @generated from field: bool had_slot_selected = 3;
   */
  hadSlotSelected: boolean;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent
 */
export type MarketplacePropertyCategory_TourFlowAbandonedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep last_step = 2;
   */
  lastStep?: MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson;

  /**
   * @generated from field: bool had_slot_selected = 3;
   */
  hadSlotSelected?: boolean;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.
 * Use `create(MarketplacePropertyCategory_TourFlowAbandonedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFlowAbandonedEventSchema: GenMessage<MarketplacePropertyCategory_TourFlowAbandonedEvent, {jsonType: MarketplacePropertyCategory_TourFlowAbandonedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 15);

/**
 * Mirrors the client's TourFlowStep navigation enum. Emitters must map
 * cases explicitly — never stringify the client value, whose confirmation
 * case carries a whole booking model.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep
 */
export enum MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep {
  /**
   * @generated from enum value: FLOW_STEP_UNSPECIFIED = 0;
   */
  FLOW_STEP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: TIME_SELECTION = 1;
   */
  TIME_SELECTION = 1,

  /**
   * @generated from enum value: LOGIN = 2;
   */
  LOGIN = 2,

  /**
   * @generated from enum value: PHONE_VERIFICATION = 3;
   */
  PHONE_VERIFICATION = 3,

  /**
   * @generated from enum value: ID_VERIFICATION = 4;
   */
  ID_VERIFICATION = 4,

  /**
   * @generated from enum value: REVIEW = 5;
   */
  REVIEW = 5,

  /**
   * @generated from enum value: CONFIRMATION = 6;
   */
  CONFIRMATION = 6,
}

/**
 * Mirrors the client's TourFlowStep navigation enum. Emitters must map
 * cases explicitly — never stringify the client value, whose confirmation
 * case carries a whole booking model.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep
 */
export type MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson = "FLOW_STEP_UNSPECIFIED" | "TIME_SELECTION" | "LOGIN" | "PHONE_VERIFICATION" | "ID_VERIFICATION" | "REVIEW" | "CONFIRMATION";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFlowAbandonedEvent.FlowStep.
 */
export const MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepSchema: GenEnum<MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStep, MarketplacePropertyCategory_TourFlowAbandonedEvent_FlowStepJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 15, 0);

/**
 * A denial is a business outcome (e.g. RETRY_THRESHOLD_REACHED blocks the
 * user from booking), not a client error — the server responds successfully
 * with a denied status, so Sentry never sees it. Kept so funnel analysis
 * can distinguish "denied" from "abandoned".
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent
 */
export type MarketplacePropertyCategory_IdvSessionDeniedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason denial_reason = 2;
   */
  denialReason: MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReason;
};

/**
 * A denial is a business outcome (e.g. RETRY_THRESHOLD_REACHED blocks the
 * user from booking), not a client error — the server responds successfully
 * with a denied status, so Sentry never sees it. Kept so funnel analysis
 * can distinguish "denied" from "abandoned".
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent
 */
export type MarketplacePropertyCategory_IdvSessionDeniedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason denial_reason = 2;
   */
  denialReason?: MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.
 * Use `create(MarketplacePropertyCategory_IdvSessionDeniedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_IdvSessionDeniedEventSchema: GenMessage<MarketplacePropertyCategory_IdvSessionDeniedEvent, {jsonType: MarketplacePropertyCategory_IdvSessionDeniedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 16);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason
 */
export enum MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReason {
  /**
   * @generated from enum value: DENIAL_REASON_UNSPECIFIED = 0;
   */
  DENIAL_REASON_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ALREADY_VERIFIED = 1;
   */
  ALREADY_VERIFIED = 1,

  /**
   * @generated from enum value: RETRY_THRESHOLD_REACHED = 2;
   */
  RETRY_THRESHOLD_REACHED = 2,

  /**
   * @generated from enum value: FEATURE_DISABLED = 3;
   */
  FEATURE_DISABLED = 3,

  /**
   * @generated from enum value: TIMED_OUT = 4;
   */
  TIMED_OUT = 4,

  /**
   * The server returned a reason this client build does not recognize.
   *
   * @generated from enum value: UNKNOWN = 5;
   */
  UNKNOWN = 5,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason
 */
export type MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonJson = "DENIAL_REASON_UNSPECIFIED" | "ALREADY_VERIFIED" | "RETRY_THRESHOLD_REACHED" | "FEATURE_DISABLED" | "TIMED_OUT" | "UNKNOWN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.IdvSessionDeniedEvent.DenialReason.
 */
export const MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonSchema: GenEnum<MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReason, MarketplacePropertyCategory_IdvSessionDeniedEvent_DenialReasonJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 16, 0);

/**
 * Tour management — cancellation funnel and post-tour feedback.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent
 */
export type MarketplacePropertyCategory_TourCancelConfirmedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent"> & {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid: string;
};

/**
 * Tour management — cancellation funnel and post-tour feedback.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent
 */
export type MarketplacePropertyCategory_TourCancelConfirmedEventJson = {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId?: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelConfirmedEvent.
 * Use `create(MarketplacePropertyCategory_TourCancelConfirmedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCancelConfirmedEventSchema: GenMessage<MarketplacePropertyCategory_TourCancelConfirmedEvent, {jsonType: MarketplacePropertyCategory_TourCancelConfirmedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 17);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent
 */
export type MarketplacePropertyCategory_TourCancelSucceededEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent"> & {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent
 */
export type MarketplacePropertyCategory_TourCancelSucceededEventJson = {
  /**
   * @generated from field: string tour_id = 1;
   */
  tourId?: string;

  /**
   * @generated from field: string address_uuid = 2;
   */
  addressUuid?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCancelSucceededEvent.
 * Use `create(MarketplacePropertyCategory_TourCancelSucceededEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCancelSucceededEventSchema: GenMessage<MarketplacePropertyCategory_TourCancelSucceededEvent, {jsonType: MarketplacePropertyCategory_TourCancelSucceededEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 18);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment sentiment = 2;
   */
  sentiment: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_Sentiment;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource source = 3;
   */
  source: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSource;

  /**
   * @generated from field: string tour_id = 4;
   */
  tourId: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment sentiment = 2;
   */
  sentiment?: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource source = 3;
   */
  source?: MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceJson;

  /**
   * @generated from field: string tour_id = 4;
   */
  tourId?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.
 * Use `create(MarketplacePropertyCategory_TourFeedbackSubmittedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourFeedbackSubmittedEventSchema: GenMessage<MarketplacePropertyCategory_TourFeedbackSubmittedEvent, {jsonType: MarketplacePropertyCategory_TourFeedbackSubmittedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 19);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment
 */
export enum MarketplacePropertyCategory_TourFeedbackSubmittedEvent_Sentiment {
  /**
   * @generated from enum value: SENTIMENT_UNSPECIFIED = 0;
   */
  SENTIMENT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: POSITIVE = 1;
   */
  POSITIVE = 1,

  /**
   * @generated from enum value: NEUTRAL = 2;
   */
  NEUTRAL = 2,

  /**
   * @generated from enum value: NEGATIVE = 3;
   */
  NEGATIVE = 3,

  /**
   * @generated from enum value: UNKNOWN = 4;
   */
  UNKNOWN = 4,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentJson = "SENTIMENT_UNSPECIFIED" | "POSITIVE" | "NEUTRAL" | "NEGATIVE" | "UNKNOWN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.Sentiment.
 */
export const MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentSchema: GenEnum<MarketplacePropertyCategory_TourFeedbackSubmittedEvent_Sentiment, MarketplacePropertyCategory_TourFeedbackSubmittedEvent_SentimentJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 19, 0);

/**
 * Which feedback surface submitted: the one-tap prompt on the Home tab
 * or the full form with aspects and free text.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource
 */
export enum MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSource {
  /**
   * @generated from enum value: FEEDBACK_SOURCE_UNSPECIFIED = 0;
   */
  FEEDBACK_SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: QUICK = 1;
   */
  QUICK = 1,

  /**
   * @generated from enum value: DETAILED = 2;
   */
  DETAILED = 2,
}

/**
 * Which feedback surface submitted: the one-tap prompt on the Home tab
 * or the full form with aspects and free text.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource
 */
export type MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceJson = "FEEDBACK_SOURCE_UNSPECIFIED" | "QUICK" | "DETAILED";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourFeedbackSubmittedEvent.FeedbackSource.
 */
export const MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceSchema: GenEnum<MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSource, MarketplacePropertyCategory_TourFeedbackSubmittedEvent_FeedbackSourceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 19, 1);

/**
 * Tour entry — the door access code loaded, marking the user's path
 * into the home after booking. Load errors and poll timeouts are Sentry
 * territory, not modeled here.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent
 */
export type MarketplacePropertyCategory_AccessCodeLoadedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType security_system_type = 3;
   */
  securitySystemType: MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemType;
};

/**
 * Tour entry — the door access code loaded, marking the user's path
 * into the home after booking. Load errors and poll timeouts are Sentry
 * territory, not modeled here.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent
 */
export type MarketplacePropertyCategory_AccessCodeLoadedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType security_system_type = 3;
   */
  securitySystemType?: MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.
 * Use `create(MarketplacePropertyCategory_AccessCodeLoadedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_AccessCodeLoadedEventSchema: GenMessage<MarketplacePropertyCategory_AccessCodeLoadedEvent, {jsonType: MarketplacePropertyCategory_AccessCodeLoadedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 20);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType
 */
export enum MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemType {
  /**
   * @generated from enum value: SECURITY_SYSTEM_TYPE_UNSPECIFIED = 0;
   */
  SECURITY_SYSTEM_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SMARTRENT = 1;
   */
  SMARTRENT = 1,

  /**
   * @generated from enum value: ARCO = 2;
   */
  ARCO = 2,

  /**
   * @generated from enum value: CLEMENTINE = 3;
   */
  CLEMENTINE = 3,

  /**
   * @generated from enum value: KNOX = 4;
   */
  KNOX = 4,

  /**
   * @generated from enum value: LINK = 5;
   */
  LINK = 5,

  /**
   * @generated from enum value: NONE = 6;
   */
  NONE = 6,

  /**
   * The server returned a vendor this client build does not recognize.
   *
   * @generated from enum value: UNKNOWN = 7;
   */
  UNKNOWN = 7,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType
 */
export type MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeJson = "SECURITY_SYSTEM_TYPE_UNSPECIFIED" | "SMARTRENT" | "ARCO" | "CLEMENTINE" | "KNOX" | "LINK" | "NONE" | "UNKNOWN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccessCodeLoadedEvent.SecuritySystemType.
 */
export const MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeSchema: GenEnum<MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemType, MarketplacePropertyCategory_AccessCodeLoadedEvent_SecuritySystemTypeJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 20, 0);

/**
 * Search funnel — fires when a search result is tapped (vs abandoned).
 * No property enrichment because the search may be address-, zone-, or
 * free-text-typed. Deliberately carries no raw query text (buyers often
 * type street addresses, including their own, and Journey forwards event
 * properties to third-party CDP destinations unredacted); query_length
 * plus the selected result's type/position cover the funnel questions.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent
 */
export type MarketplacePropertyCategory_SearchResultSelectedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType result_type = 1;
   */
  resultType: MarketplacePropertyCategory_SearchResultSelectedEvent_ResultType;

  /**
   * @generated from field: int32 query_length = 2;
   */
  queryLength: number;

  /**
   * @generated from field: int32 result_position = 3;
   */
  resultPosition: number;
};

/**
 * Search funnel — fires when a search result is tapped (vs abandoned).
 * No property enrichment because the search may be address-, zone-, or
 * free-text-typed. Deliberately carries no raw query text (buyers often
 * type street addresses, including their own, and Journey forwards event
 * properties to third-party CDP destinations unredacted); query_length
 * plus the selected result's type/position cover the funnel questions.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent
 */
export type MarketplacePropertyCategory_SearchResultSelectedEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType result_type = 1;
   */
  resultType?: MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeJson;

  /**
   * @generated from field: int32 query_length = 2;
   */
  queryLength?: number;

  /**
   * @generated from field: int32 result_position = 3;
   */
  resultPosition?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.
 * Use `create(MarketplacePropertyCategory_SearchResultSelectedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_SearchResultSelectedEventSchema: GenMessage<MarketplacePropertyCategory_SearchResultSelectedEvent, {jsonType: MarketplacePropertyCategory_SearchResultSelectedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 21);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType
 */
export enum MarketplacePropertyCategory_SearchResultSelectedEvent_ResultType {
  /**
   * @generated from enum value: RESULT_TYPE_UNSPECIFIED = 0;
   */
  RESULT_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ZONE = 1;
   */
  ZONE = 1,

  /**
   * @generated from enum value: LISTING = 2;
   */
  LISTING = 2,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType
 */
export type MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeJson = "RESULT_TYPE_UNSPECIFIED" | "ZONE" | "LISTING";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.SearchResultSelectedEvent.ResultType.
 */
export const MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeSchema: GenEnum<MarketplacePropertyCategory_SearchResultSelectedEvent_ResultType, MarketplacePropertyCategory_SearchResultSelectedEvent_ResultTypeJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 21, 0);

/**
 * Buy-tab globe usage — the map crossfades to a 3D globe past a zoom-out
 * threshold. Entered/exited pairs answer whether the globe is a navigation
 * tool (exit somewhere new) or a toy (zoom out and straight back). No
 * property enrichment: the globe frames continents, not a listing.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent
 */
export type MarketplacePropertyCategory_MapGlobeEnteredEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent"> & {
};

/**
 * Buy-tab globe usage — the map crossfades to a 3D globe past a zoom-out
 * threshold. Entered/exited pairs answer whether the globe is a navigation
 * tool (exit somewhere new) or a toy (zoom out and straight back). No
 * property enrichment: the globe frames continents, not a listing.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent
 */
export type MarketplacePropertyCategory_MapGlobeEnteredEventJson = {
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeEnteredEvent.
 * Use `create(MarketplacePropertyCategory_MapGlobeEnteredEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_MapGlobeEnteredEventSchema: GenMessage<MarketplacePropertyCategory_MapGlobeEnteredEvent, {jsonType: MarketplacePropertyCategory_MapGlobeEnteredEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 22);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent
 */
export type MarketplacePropertyCategory_MapGlobeExitedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent"> & {
  /**
   * @generated from field: int32 duration_ms = 1;
   */
  durationMs: number;

  /**
   * Exited viewing a meaningfully different area than entered (exceeds the
   * client's travel-distance threshold).
   *
   * @generated from field: bool region_changed = 2;
   */
  regionChanged: boolean;

  /**
   * Great-circle distance between the enter and exit map centers, rounded
   * to whole km. An integer by design: floats admit NaN (great-circle math
   * leaves the acos domain when the centers coincide) and nothing on the
   * ingest path validates floats. Emitters must clamp the acos/asin
   * argument to [-1, 1] before converting.
   *
   * @generated from field: int32 travel_distance_km = 3;
   */
  travelDistanceKm: number;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent
 */
export type MarketplacePropertyCategory_MapGlobeExitedEventJson = {
  /**
   * @generated from field: int32 duration_ms = 1;
   */
  durationMs?: number;

  /**
   * Exited viewing a meaningfully different area than entered (exceeds the
   * client's travel-distance threshold).
   *
   * @generated from field: bool region_changed = 2;
   */
  regionChanged?: boolean;

  /**
   * Great-circle distance between the enter and exit map centers, rounded
   * to whole km. An integer by design: floats admit NaN (great-circle math
   * leaves the acos domain when the centers coincide) and nothing on the
   * ingest path validates floats. Emitters must clamp the acos/asin
   * argument to [-1, 1] before converting.
   *
   * @generated from field: int32 travel_distance_km = 3;
   */
  travelDistanceKm?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.MapGlobeExitedEvent.
 * Use `create(MarketplacePropertyCategory_MapGlobeExitedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_MapGlobeExitedEventSchema: GenMessage<MarketplacePropertyCategory_MapGlobeExitedEvent, {jsonType: MarketplacePropertyCategory_MapGlobeExitedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 23);

/**
 * PDP photo-carousel engagement, aggregated client-side and emitted once
 * per detail-page view when the PDP closes. Compares the two navigation
 * methods (paging swipes vs long-press scrubbing); a per-gesture event
 * stream would multiply Journey volume by the number of photos paged, so
 * the client aggregates instead.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent
 */
export type MarketplacePropertyCategory_CarouselEngagementEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * Photos available in the carousel when the PDP closed.
   *
   * @generated from field: int32 photo_count = 2;
   */
  photoCount: number;

  /**
   * Distinct carousel positions displayed. A scrub sweep counts only its
   * landing photo — intermediate frames are not intentional viewings —
   * and paging inside the fullscreen lightbox counts only the photo it
   * returns the carousel to (the lightbox is a separate surface).
   *
   * @generated from field: int32 photos_viewed = 3;
   */
  photosViewed: number;

  /**
   * Page changes from carousel paging swipes.
   *
   * @generated from field: int32 swipe_count = 4;
   */
  swipeCount: number;

  /**
   * Long-press scrub activations.
   *
   * @generated from field: int32 scrub_session_count = 5;
   */
  scrubSessionCount: number;

  /**
   * Page changes made while scrubbing, across all scrub sessions.
   *
   * @generated from field: int32 scrub_photo_count = 6;
   */
  scrubPhotoCount: number;

  /**
   * Deepest carousel position displayed, including mid-scrub frames and
   * the pre-positioned landing photo. Absolute gallery position, not
   * navigation depth: compute depth as max_photo_index -
   * landing_photo_index so image-search PDPs (which land mid-array) are
   * comparable to standard PDPs (which land at 0).
   *
   * @generated from field: int32 max_photo_index = 7;
   */
  maxPhotoIndex: number;

  /**
   * Carousel position the PDP opened on: 0 for standard pins, the matched
   * photo's position for image-search pins.
   *
   * @generated from field: int32 landing_photo_index = 8;
   */
  landingPhotoIndex: number;
};

/**
 * PDP photo-carousel engagement, aggregated client-side and emitted once
 * per detail-page view when the PDP closes. Compares the two navigation
 * methods (paging swipes vs long-press scrubbing); a per-gesture event
 * stream would multiply Journey volume by the number of photos paged, so
 * the client aggregates instead.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent
 */
export type MarketplacePropertyCategory_CarouselEngagementEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * Photos available in the carousel when the PDP closed.
   *
   * @generated from field: int32 photo_count = 2;
   */
  photoCount?: number;

  /**
   * Distinct carousel positions displayed. A scrub sweep counts only its
   * landing photo — intermediate frames are not intentional viewings —
   * and paging inside the fullscreen lightbox counts only the photo it
   * returns the carousel to (the lightbox is a separate surface).
   *
   * @generated from field: int32 photos_viewed = 3;
   */
  photosViewed?: number;

  /**
   * Page changes from carousel paging swipes.
   *
   * @generated from field: int32 swipe_count = 4;
   */
  swipeCount?: number;

  /**
   * Long-press scrub activations.
   *
   * @generated from field: int32 scrub_session_count = 5;
   */
  scrubSessionCount?: number;

  /**
   * Page changes made while scrubbing, across all scrub sessions.
   *
   * @generated from field: int32 scrub_photo_count = 6;
   */
  scrubPhotoCount?: number;

  /**
   * Deepest carousel position displayed, including mid-scrub frames and
   * the pre-positioned landing photo. Absolute gallery position, not
   * navigation depth: compute depth as max_photo_index -
   * landing_photo_index so image-search PDPs (which land mid-array) are
   * comparable to standard PDPs (which land at 0).
   *
   * @generated from field: int32 max_photo_index = 7;
   */
  maxPhotoIndex?: number;

  /**
   * Carousel position the PDP opened on: 0 for standard pins, the matched
   * photo's position for image-search pins.
   *
   * @generated from field: int32 landing_photo_index = 8;
   */
  landingPhotoIndex?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.CarouselEngagementEvent.
 * Use `create(MarketplacePropertyCategory_CarouselEngagementEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_CarouselEngagementEventSchema: GenMessage<MarketplacePropertyCategory_CarouselEngagementEvent, {jsonType: MarketplacePropertyCategory_CarouselEngagementEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 24);

/**
 * Fired client-side from /homes filter/search/map interactions. No property
 * enrichment: a search spans many homes. Deliberately carries no raw query
 * text — the same CDP-forwarding concern documented on
 * SearchResultSelectedEvent applies.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent
 */
export type MarketplacePropertyCategory_PropertySearchEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent"> & {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger trigger = 1;
   */
  trigger: MarketplacePropertyCategory_PropertySearchEvent_Trigger;

  /**
   * @generated from field: string market = 2;
   */
  market: string;

  /**
   * @generated from field: int32 results_count = 3;
   */
  resultsCount: number;

  /**
   * Wrappers rather than bare ints: an unset filter must be
   * distinguishable from a real zero (e.g. min_beds of 0).
   *
   * @generated from field: google.protobuf.Int32Value min_beds = 4;
   */
  minBeds?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value min_baths = 5;
   */
  minBaths?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int64Value min_price_cents = 6;
   */
  minPriceCents?: bigint | undefined;

  /**
   * @generated from field: google.protobuf.Int64Value max_price_cents = 7;
   */
  maxPriceCents?: bigint | undefined;

  /**
   * Sort slug the user selected (e.g. "price-desc"), omitted while the
   * default ordering is in effect. Producers other than the web client may
   * send the default explicitly, so treat sort IN (NULL, "newest") as
   * default.
   *
   * @generated from field: string sort = 8;
   */
  sort: string;

  /**
   * One-based results page the interaction loaded. Bare int because
   * emitters always know the page, so 0 means the search was not paged.
   *
   * @generated from field: int32 page = 9;
   */
  page: number;
};

/**
 * Fired client-side from /homes filter/search/map interactions. No property
 * enrichment: a search spans many homes. Deliberately carries no raw query
 * text — the same CDP-forwarding concern documented on
 * SearchResultSelectedEvent applies.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent
 */
export type MarketplacePropertyCategory_PropertySearchEventJson = {
  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger trigger = 1;
   */
  trigger?: MarketplacePropertyCategory_PropertySearchEvent_TriggerJson;

  /**
   * @generated from field: string market = 2;
   */
  market?: string;

  /**
   * @generated from field: int32 results_count = 3;
   */
  resultsCount?: number;

  /**
   * Wrappers rather than bare ints: an unset filter must be
   * distinguishable from a real zero (e.g. min_beds of 0).
   *
   * @generated from field: google.protobuf.Int32Value min_beds = 4;
   */
  minBeds?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.Int32Value min_baths = 5;
   */
  minBaths?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.Int64Value min_price_cents = 6;
   */
  minPriceCents?: Int64ValueJson;

  /**
   * @generated from field: google.protobuf.Int64Value max_price_cents = 7;
   */
  maxPriceCents?: Int64ValueJson;

  /**
   * Sort slug the user selected (e.g. "price-desc"), omitted while the
   * default ordering is in effect. Producers other than the web client may
   * send the default explicitly, so treat sort IN (NULL, "newest") as
   * default.
   *
   * @generated from field: string sort = 8;
   */
  sort?: string;

  /**
   * One-based results page the interaction loaded. Bare int because
   * emitters always know the page, so 0 means the search was not paged.
   *
   * @generated from field: int32 page = 9;
   */
  page?: number;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.
 * Use `create(MarketplacePropertyCategory_PropertySearchEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_PropertySearchEventSchema: GenMessage<MarketplacePropertyCategory_PropertySearchEvent, {jsonType: MarketplacePropertyCategory_PropertySearchEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 25);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger
 */
export enum MarketplacePropertyCategory_PropertySearchEvent_Trigger {
  /**
   * @generated from enum value: TRIGGER_UNSPECIFIED = 0;
   */
  TRIGGER_UNSPECIFIED = 0,

  /**
   * @generated from enum value: FILTER_APPLY = 1;
   */
  FILTER_APPLY = 1,

  /**
   * @generated from enum value: QUICK_FILTER = 2;
   */
  QUICK_FILTER = 2,

  /**
   * @generated from enum value: MAP_MOVE = 3;
   */
  MAP_MOVE = 3,

  /**
   * @generated from enum value: LOCATION_SELECT = 4;
   */
  LOCATION_SELECT = 4,

  /**
   * @generated from enum value: SAVED_SEARCH = 5;
   */
  SAVED_SEARCH = 5,

  /**
   * @generated from enum value: RESET = 6;
   */
  RESET = 6,

  /**
   * @generated from enum value: SORT_CHANGE = 7;
   */
  SORT_CHANGE = 7,

  /**
   * A results-page turn: the paginated nav or Show more. Both fetch
   * another slice of the same search, so they share one trigger; page
   * carries the depth.
   *
   * @generated from enum value: PAGE_CHANGE = 8;
   */
  PAGE_CHANGE = 8,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger
 */
export type MarketplacePropertyCategory_PropertySearchEvent_TriggerJson = "TRIGGER_UNSPECIFIED" | "FILTER_APPLY" | "QUICK_FILTER" | "MAP_MOVE" | "LOCATION_SELECT" | "SAVED_SEARCH" | "RESET" | "SORT_CHANGE" | "PAGE_CHANGE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.PropertySearchEvent.Trigger.
 */
export const MarketplacePropertyCategory_PropertySearchEvent_TriggerSchema: GenEnum<MarketplacePropertyCategory_PropertySearchEvent_Trigger, MarketplacePropertyCategory_PropertySearchEvent_TriggerJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 25, 0);

/**
 * Fired alongside ReactionEvent on ADD_LIKE only: ad platforms need an
 * add-only signal, which ReactionEvent (carrying all four reactions under
 * one event name) cannot provide.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent
 */
export type MarketplacePropertyCategory_AddFavoriteEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string source = 2;
   */
  source: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;
};

/**
 * Fired alongside ReactionEvent on ADD_LIKE only: ad platforms need an
 * add-only signal, which ReactionEvent (carrying all four reactions under
 * one event name) cannot provide.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent
 */
export type MarketplacePropertyCategory_AddFavoriteEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string source = 2;
   */
  source?: string;

  /**
   * List price; absent when the emitting surface does not have it loaded.
   *
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.AddFavoriteEvent.
 * Use `create(MarketplacePropertyCategory_AddFavoriteEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_AddFavoriteEventSchema: GenMessage<MarketplacePropertyCategory_AddFavoriteEvent, {jsonType: MarketplacePropertyCategory_AddFavoriteEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 26);

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent
 */
export type MarketplacePropertyCategory_OfferSubmittedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string listing_offer_uuid = 2;
   */
  listingOfferUuid: string;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType: string;
};

/**
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent
 */
export type MarketplacePropertyCategory_OfferSubmittedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string listing_offer_uuid = 2;
   */
  listingOfferUuid?: string;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferSubmittedEvent.
 * Use `create(MarketplacePropertyCategory_OfferSubmittedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_OfferSubmittedEventSchema: GenMessage<MarketplacePropertyCategory_OfferSubmittedEvent, {jsonType: MarketplacePropertyCategory_OfferSubmittedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 27);

/**
 * Authenticated Buy Direct checkout step view. Distinct from offer_start
 * (PDP CTA, including guests) and offer_submitted (offer created).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent
 */
export type MarketplacePropertyCategory_OfferCheckoutStepEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.Step step = 2;
   */
  step: MarketplacePropertyCategory_OfferCheckoutStepEvent_Step;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: bigint | undefined;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType: string;
};

/**
 * Authenticated Buy Direct checkout step view. Distinct from offer_start
 * (PDP CTA, including guests) and offer_submitted (offer created).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent
 */
export type MarketplacePropertyCategory_OfferCheckoutStepEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.Step step = 2;
   */
  step?: MarketplacePropertyCategory_OfferCheckoutStepEvent_StepJson;

  /**
   * @generated from field: google.protobuf.Int64Value price_cents = 3;
   */
  priceCents?: Int64ValueJson;

  /**
   * @generated from field: string financing_type = 4;
   */
  financingType?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.
 * Use `create(MarketplacePropertyCategory_OfferCheckoutStepEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_OfferCheckoutStepEventSchema: GenMessage<MarketplacePropertyCategory_OfferCheckoutStepEvent, {jsonType: MarketplacePropertyCategory_OfferCheckoutStepEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 28);

/**
 * In-progress checkout nodes only. IDLE, CONFIRMATION, REDIRECT,
 * ACTIVE_OFFER_BLOCKED, IN_CONTRACT, and CREATE_* are not modeled.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.Step
 */
export enum MarketplacePropertyCategory_OfferCheckoutStepEvent_Step {
  /**
   * @generated from enum value: STEP_UNSPECIFIED = 0;
   */
  STEP_UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONTACT_DETAILS = 1;
   */
  CONTACT_DETAILS = 1,

  /**
   * @generated from enum value: CONTINGENT_SALE = 2;
   */
  CONTINGENT_SALE = 2,

  /**
   * @generated from enum value: FUNDING_SOURCE = 3;
   */
  FUNDING_SOURCE = 3,

  /**
   * @generated from enum value: SCHEDULE_AND_LOGISTICS = 4;
   */
  SCHEDULE_AND_LOGISTICS = 4,

  /**
   * @generated from enum value: REVIEW_CONTRACT_DETAILS = 5;
   */
  REVIEW_CONTRACT_DETAILS = 5,

  /**
   * @generated from enum value: BACKUP_OFFER_DETAILS = 6;
   */
  BACKUP_OFFER_DETAILS = 6,

  /**
   * @generated from enum value: OFFER_DEADLINE = 7;
   */
  OFFER_DEADLINE = 7,
}

/**
 * In-progress checkout nodes only. IDLE, CONFIRMATION, REDIRECT,
 * ACTIVE_OFFER_BLOCKED, IN_CONTRACT, and CREATE_* are not modeled.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.Step
 */
export type MarketplacePropertyCategory_OfferCheckoutStepEvent_StepJson = "STEP_UNSPECIFIED" | "CONTACT_DETAILS" | "CONTINGENT_SALE" | "FUNDING_SOURCE" | "SCHEDULE_AND_LOGISTICS" | "REVIEW_CONTRACT_DETAILS" | "BACKUP_OFFER_DETAILS" | "OFFER_DEADLINE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.OfferCheckoutStepEvent.Step.
 */
export const MarketplacePropertyCategory_OfferCheckoutStepEvent_StepSchema: GenEnum<MarketplacePropertyCategory_OfferCheckoutStepEvent_Step, MarketplacePropertyCategory_OfferCheckoutStepEvent_StepJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 28, 0);

/**
 * Fired on buy-side registration success (cosmos /login soft gate).
 * address_uuid is empty for organic sign-ups with no listing context;
 * Journey skips property enrichment when the identifier is empty.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent
 */
export type MarketplacePropertyCategory_AccountCreatedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod auth_method = 2;
   */
  authMethod: MarketplacePropertyCategory_AccountCreatedEvent_AuthMethod;
};

/**
 * Fired on buy-side registration success (cosmos /login soft gate).
 * address_uuid is empty for organic sign-ups with no listing context;
 * Journey skips property enrichment when the identifier is empty.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent
 */
export type MarketplacePropertyCategory_AccountCreatedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod auth_method = 2;
   */
  authMethod?: MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.
 * Use `create(MarketplacePropertyCategory_AccountCreatedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_AccountCreatedEventSchema: GenMessage<MarketplacePropertyCategory_AccountCreatedEvent, {jsonType: MarketplacePropertyCategory_AccountCreatedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 29);

/**
 * Mirrors AuthenticationCategory.AuthMethod values so emitters can map
 * one-to-one.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod
 */
export enum MarketplacePropertyCategory_AccountCreatedEvent_AuthMethod {
  /**
   * @generated from enum value: AUTH_METHOD_UNSPECIFIED = 0;
   */
  AUTH_METHOD_UNSPECIFIED = 0,

  /**
   * @generated from enum value: EMAIL_PASSWORD = 1;
   */
  EMAIL_PASSWORD = 1,

  /**
   * @generated from enum value: LITE = 2;
   */
  LITE = 2,

  /**
   * @generated from enum value: GOOGLE = 3;
   */
  GOOGLE = 3,

  /**
   * @generated from enum value: FACEBOOK = 4;
   */
  FACEBOOK = 4,

  /**
   * @generated from enum value: SESSION_ALREADY_EXISTS = 5;
   */
  SESSION_ALREADY_EXISTS = 5,

  /**
   * @generated from enum value: APPLE = 6;
   */
  APPLE = 6,
}

/**
 * Mirrors AuthenticationCategory.AuthMethod values so emitters can map
 * one-to-one.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod
 */
export type MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodJson = "AUTH_METHOD_UNSPECIFIED" | "EMAIL_PASSWORD" | "LITE" | "GOOGLE" | "FACEBOOK" | "SESSION_ALREADY_EXISTS" | "APPLE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.AccountCreatedEvent.AuthMethod.
 */
export const MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodSchema: GenEnum<MarketplacePropertyCategory_AccountCreatedEvent_AuthMethod, MarketplacePropertyCategory_AccountCreatedEvent_AuthMethodJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 29, 0);

/**
 * A Rails viewing appointment was booked. Distinct from
 * tour_booking_start (CTA intent) and tour_booking_completed (iOS
 * booking-flow stub).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent
 */
export type MarketplacePropertyCategory_TourScheduledEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp | undefined;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent: boolean;

  /**
   * UNSPECIFIED is not rare: it covers every tour booked before web
   * recorded a source.
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource: MarketplacePropertyCategory_BookingSource;
};

/**
 * A Rails viewing appointment was booked. Distinct from
 * tour_booking_start (CTA intent) and tour_booking_completed (iOS
 * booking-flow stub).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent
 */
export type MarketplacePropertyCategory_TourScheduledEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent?: boolean;

  /**
   * UNSPECIFIED is not rare: it covers every tour booked before web
   * recorded a source.
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource?: MarketplacePropertyCategory_BookingSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourScheduledEvent.
 * Use `create(MarketplacePropertyCategory_TourScheduledEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourScheduledEventSchema: GenMessage<MarketplacePropertyCategory_TourScheduledEvent, {jsonType: MarketplacePropertyCategory_TourScheduledEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 30);

/**
 * The appointment's scheduled start elapsed without cancel or reschedule.
 * ASSUMED_ELAPSED means no attendance check ran.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent
 */
export type MarketplacePropertyCategory_TourCompletedEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp | undefined;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal completion_signal = 6;
   */
  completionSignal: MarketplacePropertyCategory_TourCompletedEvent_CompletionSignal;

  /**
   * See TourScheduledEvent.booking_source.
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 7;
   */
  bookingSource: MarketplacePropertyCategory_BookingSource;
};

/**
 * The appointment's scheduled start elapsed without cancel or reschedule.
 * ASSUMED_ELAPSED means no attendance check ran.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent
 */
export type MarketplacePropertyCategory_TourCompletedEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent?: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal completion_signal = 6;
   */
  completionSignal?: MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalJson;

  /**
   * See TourScheduledEvent.booking_source.
   *
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 7;
   */
  bookingSource?: MarketplacePropertyCategory_BookingSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.
 * Use `create(MarketplacePropertyCategory_TourCompletedEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCompletedEventSchema: GenMessage<MarketplacePropertyCategory_TourCompletedEvent, {jsonType: MarketplacePropertyCategory_TourCompletedEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 31);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal
 */
export enum MarketplacePropertyCategory_TourCompletedEvent_CompletionSignal {
  /**
   * @generated from enum value: COMPLETION_SIGNAL_UNSPECIFIED = 0;
   */
  COMPLETION_SIGNAL_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSUMED_ELAPSED = 1;
   */
  ASSUMED_ELAPSED = 1,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal
 */
export type MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalJson = "COMPLETION_SIGNAL_UNSPECIFIED" | "ASSUMED_ELAPSED";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCompletedEvent.CompletionSignal.
 */
export const MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalSchema: GenEnum<MarketplacePropertyCategory_TourCompletedEvent_CompletionSignal, MarketplacePropertyCategory_TourCompletedEvent_CompletionSignalJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 31, 0);

/**
 * The PDP certainty panel entered the viewport. Fired for both experiment
 * arms; variant distinguishes them (the control arm's panel stays hidden).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent
 */
export type MarketplacePropertyCategory_CertaintyPanelViewEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string variant = 2;
   */
  variant: string;
};

/**
 * The PDP certainty panel entered the viewport. Fired for both experiment
 * arms; variant distinguishes them (the control arm's panel stays hidden).
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent
 */
export type MarketplacePropertyCategory_CertaintyPanelViewEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string variant = 2;
   */
  variant?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelViewEvent.
 * Use `create(MarketplacePropertyCategory_CertaintyPanelViewEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_CertaintyPanelViewEventSchema: GenMessage<MarketplacePropertyCategory_CertaintyPanelViewEvent, {jsonType: MarketplacePropertyCategory_CertaintyPanelViewEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 32);

/**
 * A CTA inside the PDP certainty panel was clicked.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent
 */
export type MarketplacePropertyCategory_CertaintyPanelClickEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.Row row = 2;
   */
  row: MarketplacePropertyCategory_CertaintyPanelClickEvent_Row;

  /**
   * Sub-CTA within the row (e.g. disclosures vs mortgage in the guarantee
   * row); absent when the row has a single action.
   *
   * @generated from field: string target = 3;
   */
  target: string;
};

/**
 * A CTA inside the PDP certainty panel was clicked.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent
 */
export type MarketplacePropertyCategory_CertaintyPanelClickEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.Row row = 2;
   */
  row?: MarketplacePropertyCategory_CertaintyPanelClickEvent_RowJson;

  /**
   * Sub-CTA within the row (e.g. disclosures vs mortgage in the guarantee
   * row); absent when the row has a single action.
   *
   * @generated from field: string target = 3;
   */
  target?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.
 * Use `create(MarketplacePropertyCategory_CertaintyPanelClickEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_CertaintyPanelClickEventSchema: GenMessage<MarketplacePropertyCategory_CertaintyPanelClickEvent, {jsonType: MarketplacePropertyCategory_CertaintyPanelClickEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 33);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.Row
 */
export enum MarketplacePropertyCategory_CertaintyPanelClickEvent_Row {
  /**
   * @generated from enum value: ROW_UNSPECIFIED = 0;
   */
  ROW_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PRICE_CUT = 1;
   */
  PRICE_CUT = 1,

  /**
   * @generated from enum value: MONTHLY_COST = 2;
   */
  MONTHLY_COST = 2,

  /**
   * @generated from enum value: KEYS_BY = 3;
   */
  KEYS_BY = 3,

  /**
   * @generated from enum value: GUARANTEE = 4;
   */
  GUARANTEE = 4,

  /**
   * @generated from enum value: ACTIVITY = 5;
   */
  ACTIVITY = 5,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.Row
 */
export type MarketplacePropertyCategory_CertaintyPanelClickEvent_RowJson = "ROW_UNSPECIFIED" | "PRICE_CUT" | "MONTHLY_COST" | "KEYS_BY" | "GUARANTEE" | "ACTIVITY";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.CertaintyPanelClickEvent.Row.
 */
export const MarketplacePropertyCategory_CertaintyPanelClickEvent_RowSchema: GenEnum<MarketplacePropertyCategory_CertaintyPanelClickEvent_Row, MarketplacePropertyCategory_CertaintyPanelClickEvent_RowJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 33, 0);

/**
 * The PDP media slot settled on a state and rendered it. Fired for every
 * arm, control included: play rate and engagement are rates over this
 * event, so an arm that does not emit it has no denominator.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent
 */
export type MarketplacePropertyCategory_ListingMediaImpressionEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState media_state = 2;
   */
  mediaState: MarketplacePropertyCategory_ListingMediaState;

  /**
   * Experiment that decided the state, absent when the slot rendered
   * outside any experiment.
   *
   * @generated from field: string experiment_key = 3;
   */
  experimentKey: string;

  /**
   * @generated from field: string variant = 4;
   */
  variant: string;
};

/**
 * The PDP media slot settled on a state and rendered it. Fired for every
 * arm, control included: play rate and engagement are rates over this
 * event, so an arm that does not emit it has no denominator.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent
 */
export type MarketplacePropertyCategory_ListingMediaImpressionEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState media_state = 2;
   */
  mediaState?: MarketplacePropertyCategory_ListingMediaStateJson;

  /**
   * Experiment that decided the state, absent when the slot rendered
   * outside any experiment.
   *
   * @generated from field: string experiment_key = 3;
   */
  experimentKey?: string;

  /**
   * @generated from field: string variant = 4;
   */
  variant?: string;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaImpressionEvent.
 * Use `create(MarketplacePropertyCategory_ListingMediaImpressionEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ListingMediaImpressionEventSchema: GenMessage<MarketplacePropertyCategory_ListingMediaImpressionEvent, {jsonType: MarketplacePropertyCategory_ListingMediaImpressionEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 34);

/**
 * A viewer moved the media slot between states (e.g. the Video/Photos
 * toggle). Both endpoints are carried rather than a direction so the slot
 * stays measurable as states are added.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent
 */
export type MarketplacePropertyCategory_ListingMediaToggleEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState from_state = 2;
   */
  fromState: MarketplacePropertyCategory_ListingMediaState;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState to_state = 3;
   */
  toState: MarketplacePropertyCategory_ListingMediaState;
};

/**
 * A viewer moved the media slot between states (e.g. the Video/Photos
 * toggle). Both endpoints are carried rather than a direction so the slot
 * stays measurable as states are added.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent
 */
export type MarketplacePropertyCategory_ListingMediaToggleEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState from_state = 2;
   */
  fromState?: MarketplacePropertyCategory_ListingMediaStateJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState to_state = 3;
   */
  toState?: MarketplacePropertyCategory_ListingMediaStateJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaToggleEvent.
 * Use `create(MarketplacePropertyCategory_ListingMediaToggleEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ListingMediaToggleEventSchema: GenMessage<MarketplacePropertyCategory_ListingMediaToggleEvent, {jsonType: MarketplacePropertyCategory_ListingMediaToggleEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 35);

/**
 * One event per playback milestone reached, so play rate and completion are
 * both rates over ListingMediaImpressionEvent rather than separate funnels.
 * A milestone fires at most once per playback session; seeking past one
 * still reports it, at the position playback landed on. A session ends at
 * COMPLETE or when the listing changes, so resuming from a pause continues
 * the current session rather than starting another one.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent
 */
export type MarketplacePropertyCategory_ListingVideoPlaybackEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.Milestone milestone = 2;
   */
  milestone: MarketplacePropertyCategory_ListingVideoPlaybackEvent_Milestone;

  /**
   * Wrappers rather than bare ints: a milestone reported before metadata
   * loads has no position, which a real 0 must stay distinguishable from.
   *
   * @generated from field: google.protobuf.Int32Value position_seconds = 3;
   */
  positionSeconds?: number | undefined;

  /**
   * @generated from field: google.protobuf.Int32Value duration_seconds = 4;
   */
  durationSeconds?: number | undefined;
};

/**
 * One event per playback milestone reached, so play rate and completion are
 * both rates over ListingMediaImpressionEvent rather than separate funnels.
 * A milestone fires at most once per playback session; seeking past one
 * still reports it, at the position playback landed on. A session ends at
 * COMPLETE or when the listing changes, so resuming from a pause continues
 * the current session rather than starting another one.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent
 */
export type MarketplacePropertyCategory_ListingVideoPlaybackEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.Milestone milestone = 2;
   */
  milestone?: MarketplacePropertyCategory_ListingVideoPlaybackEvent_MilestoneJson;

  /**
   * Wrappers rather than bare ints: a milestone reported before metadata
   * loads has no position, which a real 0 must stay distinguishable from.
   *
   * @generated from field: google.protobuf.Int32Value position_seconds = 3;
   */
  positionSeconds?: Int32ValueJson;

  /**
   * @generated from field: google.protobuf.Int32Value duration_seconds = 4;
   */
  durationSeconds?: Int32ValueJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.
 * Use `create(MarketplacePropertyCategory_ListingVideoPlaybackEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_ListingVideoPlaybackEventSchema: GenMessage<MarketplacePropertyCategory_ListingVideoPlaybackEvent, {jsonType: MarketplacePropertyCategory_ListingVideoPlaybackEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 36);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.Milestone
 */
export enum MarketplacePropertyCategory_ListingVideoPlaybackEvent_Milestone {
  /**
   * @generated from enum value: MILESTONE_UNSPECIFIED = 0;
   */
  MILESTONE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLAY_START = 1;
   */
  PLAY_START = 1,

  /**
   * @generated from enum value: QUARTILE_25 = 2;
   */
  QUARTILE_25 = 2,

  /**
   * @generated from enum value: QUARTILE_50 = 3;
   */
  QUARTILE_50 = 3,

  /**
   * @generated from enum value: QUARTILE_75 = 4;
   */
  QUARTILE_75 = 4,

  /**
   * @generated from enum value: COMPLETE = 5;
   */
  COMPLETE = 5,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.Milestone
 */
export type MarketplacePropertyCategory_ListingVideoPlaybackEvent_MilestoneJson = "MILESTONE_UNSPECIFIED" | "PLAY_START" | "QUARTILE_25" | "QUARTILE_50" | "QUARTILE_75" | "COMPLETE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingVideoPlaybackEvent.Milestone.
 */
export const MarketplacePropertyCategory_ListingVideoPlaybackEvent_MilestoneSchema: GenEnum<MarketplacePropertyCategory_ListingVideoPlaybackEvent_Milestone, MarketplacePropertyCategory_ListingVideoPlaybackEvent_MilestoneJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 36, 0);

/**
 * A Rails viewing appointment was canceled. This authoritative lifecycle
 * outcome is distinct from the iOS cancel-confirmed and cancel-succeeded
 * interaction events.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent
 */
export type MarketplacePropertyCategory_TourCanceledEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp | undefined;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource: MarketplacePropertyCategory_BookingSource;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.CancellationSource cancellation_source = 7;
   */
  cancellationSource: MarketplacePropertyCategory_TourCanceledEvent_CancellationSource;
};

/**
 * A Rails viewing appointment was canceled. This authoritative lifecycle
 * outcome is distinct from the iOS cancel-confirmed and cancel-succeeded
 * interaction events.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent
 */
export type MarketplacePropertyCategory_TourCanceledEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent?: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource?: MarketplacePropertyCategory_BookingSourceJson;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.CancellationSource cancellation_source = 7;
   */
  cancellationSource?: MarketplacePropertyCategory_TourCanceledEvent_CancellationSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.
 * Use `create(MarketplacePropertyCategory_TourCanceledEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourCanceledEventSchema: GenMessage<MarketplacePropertyCategory_TourCanceledEvent, {jsonType: MarketplacePropertyCategory_TourCanceledEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 37);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.CancellationSource
 */
export enum MarketplacePropertyCategory_TourCanceledEvent_CancellationSource {
  /**
   * @generated from enum value: CANCELLATION_SOURCE_UNSPECIFIED = 0;
   */
  CANCELLATION_SOURCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SELF_TOUR = 1;
   */
  SELF_TOUR = 1,

  /**
   * @generated from enum value: SHOWING_TIME = 2;
   */
  SHOWING_TIME = 2,

  /**
   * @generated from enum value: OPENDOOR_ADMIN = 3;
   */
  OPENDOOR_ADMIN = 3,

  /**
   * @generated from enum value: LISTING_STATUS = 4;
   */
  LISTING_STATUS = 4,

  /**
   * @generated from enum value: OPENDOOR = 5;
   */
  OPENDOOR = 5,

  /**
   * @generated from enum value: UNKNOWN = 6;
   */
  UNKNOWN = 6,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.CancellationSource
 */
export type MarketplacePropertyCategory_TourCanceledEvent_CancellationSourceJson = "CANCELLATION_SOURCE_UNSPECIFIED" | "SELF_TOUR" | "SHOWING_TIME" | "OPENDOOR_ADMIN" | "LISTING_STATUS" | "OPENDOOR" | "UNKNOWN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.TourCanceledEvent.CancellationSource.
 */
export const MarketplacePropertyCategory_TourCanceledEvent_CancellationSourceSchema: GenEnum<MarketplacePropertyCategory_TourCanceledEvent_CancellationSource, MarketplacePropertyCategory_TourCanceledEvent_CancellationSourceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 37, 0);

/**
 * A Rails viewing appointment was moved to a new time while retaining its
 * appointment identity.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent
 */
export type MarketplacePropertyCategory_TourRescheduledEvent = Message<"od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent"> & {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: Timestamp | undefined;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource: MarketplacePropertyCategory_BookingSource;
};

/**
 * A Rails viewing appointment was moved to a new time while retaining its
 * appointment identity.
 *
 * @generated from message od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent
 */
export type MarketplacePropertyCategory_TourRescheduledEventJson = {
  /**
   * @generated from field: string address_uuid = 1;
   */
  addressUuid?: string;

  /**
   * @generated from field: string tour_id = 2;
   */
  tourId?: string;

  /**
   * @generated from field: string listing_id = 3;
   */
  listingId?: string;

  /**
   * @generated from field: google.protobuf.Timestamp scheduled_for = 4;
   */
  scheduledFor?: TimestampJson;

  /**
   * @generated from field: bool is_agent = 5;
   */
  isAgent?: boolean;

  /**
   * @generated from field: od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource booking_source = 6;
   */
  bookingSource?: MarketplacePropertyCategory_BookingSourceJson;
};

/**
 * Describes the message od_protos.journey.data.categories.MarketplacePropertyCategory.TourRescheduledEvent.
 * Use `create(MarketplacePropertyCategory_TourRescheduledEventSchema)` to create a new message.
 */
export const MarketplacePropertyCategory_TourRescheduledEventSchema: GenMessage<MarketplacePropertyCategory_TourRescheduledEvent, {jsonType: MarketplacePropertyCategory_TourRescheduledEventJson}> = /*@__PURE__*/
  messageDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 38);

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction
 */
export enum MarketplacePropertyCategory_ReactionEventReaction {
  /**
   * @generated from enum value: REACTION_UNSPECIFIED = 0;
   */
  REACTION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: REACTION_ADD_LIKE = 1;
   */
  REACTION_ADD_LIKE = 1,

  /**
   * @generated from enum value: REACTION_REMOVE_LIKE = 2;
   */
  REACTION_REMOVE_LIKE = 2,

  /**
   * @generated from enum value: REACTION_ADD_DISLIKE = 3;
   */
  REACTION_ADD_DISLIKE = 3,

  /**
   * @generated from enum value: REACTION_REMOVE_DISLIKE = 4;
   */
  REACTION_REMOVE_DISLIKE = 4,
}

/**
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction
 */
export type MarketplacePropertyCategory_ReactionEventReactionJson = "REACTION_UNSPECIFIED" | "REACTION_ADD_LIKE" | "REACTION_REMOVE_LIKE" | "REACTION_ADD_DISLIKE" | "REACTION_REMOVE_DISLIKE";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.ReactionEventReaction.
 */
export const MarketplacePropertyCategory_ReactionEventReactionSchema: GenEnum<MarketplacePropertyCategory_ReactionEventReaction, MarketplacePropertyCategory_ReactionEventReactionJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 0);

/**
 * Media the PDP media slot can occupy. Shared by the impression, toggle,
 * and playback events, and deliberately open-ended: the slot's arms are
 * decided by separate experiments over disjoint inventory, so the count of
 * states it can hold grows independently of any one of them.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState
 */
export enum MarketplacePropertyCategory_ListingMediaState {
  /**
   * @generated from enum value: LISTING_MEDIA_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: LISTING_MEDIA_STATE_PHOTOS = 1;
   */
  PHOTOS = 1,

  /**
   * @generated from enum value: LISTING_MEDIA_STATE_VIDEO = 2;
   */
  VIDEO = 2,

  /**
   * @generated from enum value: LISTING_MEDIA_STATE_TOUR_3D = 3;
   */
  TOUR_3D = 3,

  /**
   * @generated from enum value: LISTING_MEDIA_STATE_FLOOR_PLAN = 4;
   */
  FLOOR_PLAN = 4,
}

/**
 * Media the PDP media slot can occupy. Shared by the impression, toggle,
 * and playback events, and deliberately open-ended: the slot's arms are
 * decided by separate experiments over disjoint inventory, so the count of
 * states it can hold grows independently of any one of them.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState
 */
export type MarketplacePropertyCategory_ListingMediaStateJson = "LISTING_MEDIA_STATE_UNSPECIFIED" | "LISTING_MEDIA_STATE_PHOTOS" | "LISTING_MEDIA_STATE_VIDEO" | "LISTING_MEDIA_STATE_TOUR_3D" | "LISTING_MEDIA_STATE_FLOOR_PLAN";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.ListingMediaState.
 */
export const MarketplacePropertyCategory_ListingMediaStateSchema: GenEnum<MarketplacePropertyCategory_ListingMediaState, MarketplacePropertyCategory_ListingMediaStateJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 1);

/**
 * Shared by TourVerificationStartedEvent and TourVerificationCompletedEvent.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep
 */
export enum MarketplacePropertyCategory_VerificationStep {
  /**
   * @generated from enum value: VERIFICATION_STEP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VERIFICATION_STEP_LOGIN = 1;
   */
  LOGIN = 1,

  /**
   * @generated from enum value: VERIFICATION_STEP_PHONE = 2;
   */
  PHONE = 2,

  /**
   * @generated from enum value: VERIFICATION_STEP_IDENTITY = 3;
   */
  IDENTITY = 3,
}

/**
 * Shared by TourVerificationStartedEvent and TourVerificationCompletedEvent.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep
 */
export type MarketplacePropertyCategory_VerificationStepJson = "VERIFICATION_STEP_UNSPECIFIED" | "VERIFICATION_STEP_LOGIN" | "VERIFICATION_STEP_PHONE" | "VERIFICATION_STEP_IDENTITY";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.VerificationStep.
 */
export const MarketplacePropertyCategory_VerificationStepSchema: GenEnum<MarketplacePropertyCategory_VerificationStep, MarketplacePropertyCategory_VerificationStepJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 2);

/**
 * Shared by TourScheduledEvent and TourCompletedEvent. Mirrors
 * od_protos.web.data.viewing_appointment.BookingSource values so
 * emitters can map one-to-one.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource
 */
export enum MarketplacePropertyCategory_BookingSource {
  /**
   * @generated from enum value: BOOKING_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOOKING_SOURCE_INTERNAL_API = 1;
   */
  INTERNAL_API = 1,

  /**
   * @generated from enum value: BOOKING_SOURCE_MOBILE_V1 = 2;
   */
  MOBILE_V1 = 2,

  /**
   * @generated from enum value: BOOKING_SOURCE_ADMIN = 3;
   */
  ADMIN = 3,

  /**
   * @generated from enum value: BOOKING_SOURCE_SHOWINGTIME = 4;
   */
  SHOWINGTIME = 4,
}

/**
 * Shared by TourScheduledEvent and TourCompletedEvent. Mirrors
 * od_protos.web.data.viewing_appointment.BookingSource values so
 * emitters can map one-to-one.
 *
 * @generated from enum od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource
 */
export type MarketplacePropertyCategory_BookingSourceJson = "BOOKING_SOURCE_UNSPECIFIED" | "BOOKING_SOURCE_INTERNAL_API" | "BOOKING_SOURCE_MOBILE_V1" | "BOOKING_SOURCE_ADMIN" | "BOOKING_SOURCE_SHOWINGTIME";

/**
 * Describes the enum od_protos.journey.data.categories.MarketplacePropertyCategory.BookingSource.
 */
export const MarketplacePropertyCategory_BookingSourceSchema: GenEnum<MarketplacePropertyCategory_BookingSource, MarketplacePropertyCategory_BookingSourceJson> = /*@__PURE__*/
  enumDesc(file_protobuf_journey_data_categories_marketplace_property_category, 0, 3);

